import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
};

const followupReminderSlice = createSlice({
  name: "followupReminder",
  initialState,
  reducers: {
    addFollowupReminder(state, action) {
      // If state.data isn't an array, reset it to an empty array
      if (!Array.isArray(state.data)) {
        state.data = [];
      }
      state.data.push(action.payload);
    },
    clearFollowupReminders(state) {
      state.data = [];
    },
  },
});

export const { addFollowupReminder, clearFollowupReminders } =
  followupReminderSlice.actions;
export default followupReminderSlice.reducer;
